import { Button } from '@material-ui/core'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'

import { useBulkTableStyles } from './styles'

interface ApplyToAllHeaderProps {
  ariaLabel: string
  compact?: boolean
  disabled?: boolean
  onApply: () => void
  children: React.ReactNode
}

const ApplyToAllHeader = ({ ariaLabel, compact = false, disabled = false, onApply, children }: ApplyToAllHeaderProps) => {
  const classes = useBulkTableStyles()
  return (
    <div className={classes.applyRow}>
      {children}
      <Button
        aria-label={ariaLabel}
        className={`${classes.applyButton} ${compact ? classes.compactApplyButton : ''}`}
        color='primary'
        disabled={disabled}
        onClick={onApply}
        size='small'
        variant='outlined'
      >
        <ArrowDownwardIcon fontSize='small' />
      </Button>
    </div>
  )
}

export default ApplyToAllHeader
